import styled from 'styled-components';

export const BoxParagraph = styled.h4`
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 20px;
  color: ${(props) => props.color};
  text-transform: ${(props) => props.textTransform};
`;
